import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireAccess = false }) {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-wash" data-testid="route-loading">
        <div className="text-lav font-heading italic text-2xl animate-pulse">One moment…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAccess && !user.has_access) return <Navigate to="/join" replace />;
  return children;
}
